module.exports = __webpack_public_path__ + "assets/media/4.d94afeac.wav";